fragment GlobalNewsletterSignupFormFragment on newsletterSignup_GlobalSet {
  simpleHeading
  headline
  teaser
  description
  legalText
  buttonText
  theme
  textAlign
  image {
    url
    title
  }
  imagePosition
  mailchimpListId
  mailchimpTags
  newsletterBackend
}
